<h2 mat-dialog-title>Actualizar parámetro de configuración</h2>
<form [formGroup]="patchConfigurationParameterForm" (ngSubmit)="managePatchConfigurationParameter()">
    <mat-dialog-content>
        <mat-slide-toggle class="form-field is-image-toggle" formControlName="isImage" labelPosition="before">
            <p>
                {{patchConfigurationParameterForm.controls.isImage.getRawValue()?"Subir imagen":"Ingresar texto"}}
            </p>
        </mat-slide-toggle>

        @if (patchConfigurationParameterForm.controls.isImage.getRawValue()) {
        <div class="files-container">
            <file-upload class="file-upload" formControlName="files" [multiple]="true" [animation]="false">
                <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
                    <file-upload-drop-zone>
                        <b>Arrastre y suelte</b> archivos o click aqu&iacute;
                    </file-upload-drop-zone>
                </ng-template>
                <ng-template let-i="index" let-file="file" let-control="control" #item>
                  <file-upload-list-item  [index]="i" [file]="file" [control]="control">Remover</file-upload-list-item>
                </ng-template>
            </file-upload>
            @if (patchConfigurationParameterForm.controls.files.hasError('filesLimit')) {
            <mat-error class="files-container-label">{{ filesLimitMessageError }}</mat-error>
            }
            @if (patchConfigurationParameterForm.controls.files.hasError('sizeLimit')) {
            <mat-error class="files-container-label">M&aacute;ximo 40 MB</mat-error>
            }@else{
            <mat-label class="files-container-label">{{updateKBsUsedDisplay()}}</mat-label>
            }
        </div>
        @if (!isBase64(configuracion.texto)) {
        <div style="padding: 0.5rem;">
            <p>Imagen actual</p>
            <img style="max-width: 425px;" [src]="renderBase64(configuracion.texto)" alt="miniature">
        </div>
        }
        }@else {
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Texto</mat-label>
            <input matInput formControlName="texto" type="text" autofocus>
        </mat-form-field>
        }
        <mat-form-field class="form-field" appearance="outline">
            <mat-label>Número</mat-label>
            <input formControlName="numero" type="number" min="0" matInput>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button type="button" mat-button mat-dialog-close>Cancelar</button>
        <button type="submit" mat-flat-button
            [disabled]="!patchConfigurationParameterForm.valid || patchingConfigurationParameter">
            @if (patchingConfigurationParameter) {
            <mat-spinner diameter="20" color="warn"></mat-spinner>
            }@else {
            <p>Actualizar</p>
            }
        </button>
    </mat-dialog-actions>
</form>
